import { get } from 'lodash';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const useProgressiveLoad = (data, prop) => {
  const [inViewRef, isInView] = useInView();
  const [isLoading, setLoading] = useState(false);
  const [hasErrors, setErrors] = useState(false);

  const getCollection = useCallback(() => get(data, prop), [data, prop]);

  const load = useCallback(() => {
    if (!isLoading && !hasErrors) {
      setErrors(false);
      setLoading(true);
      try {
        getCollection()
          .init()
          .then(() => {
            setLoading(false);
          });
        setErrors(getCollection().hasErrors);
      } catch (err) {
        setErrors(err);
        setLoading(false);
      }
    }
  }, [isLoading, hasErrors, getCollection]);

  useEffect(() => {
    if (isInView) {
      load();
    }
  }, [isInView, load]);

  return {
    data,
    prop,
    inViewRef,
    isLoading,
    hasErrors
  };
};

useProgressiveLoad.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  prop: PropTypes.string.isRequired,
  updated: PropTypes.string
};

useProgressiveLoad.defaultProps = {
  updated: undefined
};

export default useProgressiveLoad;
